import initMadeCategoryPrint from "components/jiffy/made-category-print/made-category-print";
import initMadeCategory from "components/jiffy/made-category/made-category";
import { loadCarousel } from "components/jiffy/made-category/lazy-components";

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".js-made-category-print")) {
    initMadeCategoryPrint();
  } else {
    initMadeCategory();
    loadCarousel();
  }
});
